import { useEffect } from 'react';
import { AtlassianAppTileCompact } from '../AppTile/AtlassianAppTileCompact';
import { AppGridSection } from './AppGridSection';
import { jsx as _jsx } from "react/jsx-runtime";
export const AtlassianAppGridSection = _ref => {
  let {
    gridVars,
    atlassianApps,
    onAtlassianAppSectionViewed
  } = _ref;
  useEffect(() => {
    onAtlassianAppSectionViewed === null || onAtlassianAppSectionViewed === void 0 ? void 0 : onAtlassianAppSectionViewed();
  }, []);
  if (!Array.isArray(atlassianApps) || atlassianApps.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(AppGridSection, {
    title: "Atlassian apps",
    gridVars: gridVars,
    children: atlassianApps.map(app => /*#__PURE__*/_jsx(AtlassianAppTileCompact, {
      productName: app.productName,
      description: app.description,
      onClick: app.onClick,
      brandIcon: /*#__PURE__*/_jsx(app.brandIcon, {
        size: "medium",
        appearance: "brand",
        shouldUseNewLogoDesign: true
      })
    }, "atlassian-app-".concat(app.productName)))
  });
};